var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-210.000000, -356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-add-image",
    transform: "translate(210.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#DCE4F4",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(7.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 1,
    y: 1,
    width: 11,
    height: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-image",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7,0 L1.3,0 C0.58175,0 0,0.559375 0,1.25 L0,8.75 C0,9.440625 0.58175,10 1.3,10 L11.7,10 C12.41825,10 13,9.440625 13,8.75 L13,1.25 C13,0.559375 12.41825,0 11.7,0 Z M5.2,2.5 C5.5588,2.5 5.85,2.78 5.85,3.125 C5.85,3.47 5.5588,3.75 5.2,3.75 C4.8412,3.75 4.55,3.47 4.55,3.125 C4.55,2.78 4.8412,2.5 5.2,2.5 Z M11.05,8.125 L1.95,8.125 L4.22435,5.313125 L5.85,7.19375 L8.125,4.375625 L11.05,8.125 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteAddImage);
export default __webpack_public_path__ + "static/media/icon-rte-add-image.0533df54bbd87d90207fe1c64f3d6312.svg";
export { ForwardRef as ReactComponent };